module.exports = __webpack_public_path__ + "static/media/sx.2ce155b8.svg";